import {
  Component,
  input,
  Input,
  OnInit,
} from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALUE_ACCESSOR, ValidationErrors, Validator } from '@angular/forms';
import { ChildrenAnimation } from 'src/app/shared/animations/allAnimations';
import { ZenButtonType } from '../../directives/button-style.directive';

@Component({
  selector: 'z-input',
  templateUrl: './zen-input.component.html',
  styleUrls: ['./zen-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: ZenInputComponent,
    },
  ],
  animations: [ChildrenAnimation]
})
export class ZenInputComponent implements ControlValueAccessor {
  readonly customClass = input<string>('h-10 text-sm');
  ZenButtonType = ZenButtonType;
  constructor() { }



  emailPattern = '^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$';
  @Input() email: boolean = false;
  @Input() password: boolean = false;
  @Input() required: boolean = false;
  @Input() number: boolean = false;
  @Input() invalid: boolean = false;
  @Input() label;
  @Input() placeholder;
  @Input() maxCount
  @Input() language
  selected;
  hide: boolean = true;
  isDisabled: boolean = false;
  disable: boolean = false;
  onChange: any = () => { };
  onTouch: any = () => { };

  writeValue(selected: any) {
    if (selected !== undefined && this.selected !== selected) {
      this.selected = selected;
    }
  }

  registerOnChange(fn: any) {

    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }
  handleChange(option) {
    this.selected = option;
    this.onChange(option);
  }
  change(e) {
    if (this.number) {
      const initalValue = e.target.value;
      e.target.value = initalValue.replace(/[^0-9-]+/g, '');

      if (initalValue !== e.target.value)
        e.stopPropagation();

    }
  }

  toggleHide() {
    this.hide = !this.hide;
  }

}

